import { Flex } from "antd";
import { ItemInfoBlock } from "components/ItemInfo";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";
import { refundCustomTokens, refundTokenRequest } from "services/walletTokens";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { parseErrorMessage } from "utils";
import { getConfirmColumns } from "./getColumns";

type Props = {
  balance: number;
  wallet: string;
  dataToSend: refundTokenRequest["requestBody"]["content"]["application/json"];
};

export const ConfirmReturnTokensModal = observer((props: Props) => {
  const { actionModals, bidCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const refundTokens = async () => {
    if (!bidCard.bid.transitWallet) return;
    setLoading(true);

    await refundCustomTokens(bidCard.bid.transitWallet, props.dataToSend)
      .then(() => {
        actionModals.closeAll();
        openNotification({
          message: "Запрос успешно отправлен",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
      })
      .catch((e) => {
        openNotification({
          description: parseErrorMessage(e),
          type: NOTIFICATION_TYPE_ENUM.ERROR,
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Flex vertical gap="large">
      <ItemInfoBlock items={getConfirmColumns(props.balance, props.wallet)} />
      <Flex gap="large">
        <CustomButton htmlType="submit" disabled={loading} loading={loading} onClick={refundTokens}>
          Подтвердить
        </CustomButton>
        <CustomButton
          htmlType="button"
          disabled={loading}
          loading={loading}
          type="default"
          onClick={() => actionModals.closeAll()}
        >
          Отмена
        </CustomButton>
      </Flex>
    </Flex>
  );
});
